// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__2dG00","consentsList":"PatientConsents_consentsList__2RODY","consentsListEmpty":"PatientConsents_consentsListEmpty__3Kve0"};